import { chain, size, sortBy } from 'underscore';

export const Genders = {
  Female: _TL_('Female'),
  Male: _TL_('Male'),
  Unknown: _TL_('Unknown'),
};

const sortGenders = genders => sortBy(genders, gender => Genders[gender]);

export const formatGender = (gender, i18n) => (Genders[gender] ? i18n.getString(Genders[gender]) : gender);

export const formatGenders = (genders, i18n) => {
  if (size(genders) === size(Genders)) {
    return `{{dataTag}}${i18n.getString(_TL_('All genders'))}{{/dataTag}}`;
  }

  return chain(sortGenders(genders))
    .map(gender => `{{dataTag}}${formatGender(gender, i18n)}{{/dataTag}}`)
    .join(i18n.getString(_TL_(', ')))
    .value();
};
